import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import removeEmpty from '../../../utils/removeEmptyValuesFromObject';

const fetchFixedBudgetVesselQuery = (data) => {
  const cleanedData = removeEmpty(data);
  return axios.post(apiurl?.getFixedBudgetVesselList, cleanedData);
};

const fetchFixedBudgetVessels = (data) => {
  return useQuery(
    ['getFixedBudgetVesselList', data],
    () => fetchFixedBudgetVesselQuery(data),
    { refetchOnWindowFocus: false }
  );
};

export default fetchFixedBudgetVessels;
